import { supabase } from './supabase';

// -------------------------------------------------------------------
// HDR File Manager — CRUD for villa_hdr_files table
// -------------------------------------------------------------------

export interface HDRFile {
    id: string;
    name: string;
    url: string;
    cloudinary_public_id: string | null;
    sun_time: number;
    is_default: boolean;
    created_at: string;
}

/**
 * Fetch all available HDR files, ordered by creation date.
 */
export async function fetchAllHDRs(): Promise<HDRFile[]> {
    const { data, error } = await supabase
        .from('villa_hdr_files')
        .select('*')
        .order('created_at', { ascending: true });

    if (error) {
        console.error('[HDR] Failed to fetch:', error);
        return [];
    }

    return data || [];
}

/**
 * Create (register) a new HDR file after Cloudinary upload.
 */
export async function createHDR(input: {
    name: string;
    url: string;
    cloudinary_public_id?: string;
    sun_time?: number;
}): Promise<HDRFile | null> {
    const { data, error } = await supabase
        .from('villa_hdr_files')
        .insert({
            name: input.name,
            url: input.url,
            cloudinary_public_id: input.cloudinary_public_id || null,
            sun_time: input.sun_time ?? 12.0,
            is_default: false,
        })
        .select()
        .single();

    if (error) {
        console.error('[HDR] Failed to create:', error);
        throw error;
    }

    return data;
}

/**
 * Delete an HDR file record from the database.
 */
export async function deleteHDR(id: string): Promise<void> {
    const { error } = await supabase
        .from('villa_hdr_files')
        .delete()
        .eq('id', id);

    if (error) {
        console.error('[HDR] Failed to delete:', error);
        throw error;
    }
}
